import { ListBoxPrimeReact } from "@finanedi.es/storybook"
import { faFile } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FlujoAprobacionReadingDtoProps } from "api/DTOs/FlujoAprobacionReadingDto"
import React from "react"
import { useTranslation } from "react-i18next"
import { TIPO_DOC_LABEL } from "../constants/tipo-doc-label"
import { TypeOptionProps } from "../types/aprovals-management-types"

export const TypeNav: React.FC<{
  groups: Record<number, FlujoAprobacionReadingDtoProps[]>
  active: number | null
  onSelect: (tipo: number) => void
}> = ({ groups, active, onSelect }) => {
  const { t } = useTranslation()
  const options: TypeOptionProps[] = React.useMemo(() => {
    return Object.entries(groups)
      .map(([tipoStr, reglas]) => ({
        value: Number(tipoStr),
        label: TIPO_DOC_LABEL(t)[Number(tipoStr)] ?? `Tipo ${tipoStr}`,
        count: reglas.length,
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
  }, [groups, t])

  return (
    <div className='tw-shadow-sm tw-border tw-rounded-md tw-bg-white'>
      <div className='tw-p-3 tw-pr-10 tw-border-b'>
        <h3 className='tw-text-sm tw-font-medium'>
          {t("flujoAprobaciones.items.documentType")}
        </h3>
      </div>
      <ListBoxPrimeReact
        value={active}
        options={options}
        optionLabel='label'
        optionValue='value'
        onChange={(e) => e?.value && onSelect(e.value)}
        className='tw-w-full tw-border-none'
        listClassName='tw-max-h-[60vh] tw-overflow-auto tw-border-none'
        itemTemplate={(opt: TypeOptionProps) => (
          <div className='tw-flex tw-items-center tw-gap-3 tw-w-full'>
            <FontAwesomeIcon
              icon={faFile}
              className='tw-text-lg tw-text-secondary tw-size-5'
            />
            <div className='tw-flex-1'>
              <div className='tw-text-sm tw-font-medium'>{opt.label}</div>
              <div className='tw-text-xs tw-opacity-70'>
                {t("flujoAprobaciones.rules.regla", { count: opt.count })}
              </div>
            </div>
          </div>
        )}
      />
    </div>
  )
}
